/*
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-11 10:18:26
 * @Description:
 */
import http from '../http'
import url from './index-url'
const { post, get } = http

export default {
  getStudentList(data) {
    return post(url.studentList, data)
  },
  insQuota(data) {
    return post(url.insQuota, data)
  },
  updRight(data) {
    return post(url.updRight, data)
  },
  getList(data) {
    return post(url.rightList, data)
  },
  rightApproval(data) {
    return post(url.rightApproval, data)
  },
  xkhCardType() {
    return get(url.xkhCardType)
  },
  getLogList(data) {
    return post(url.getLogList, data)
  },
  batchReject(data) {
    return post(url.batchReject, data)
  },
  batchPass(data) {
    return post(url.batchPass, data)
  },
  getCiCardList(data) {
    return post(url.ciCardList, data)
  }
}